import React from 'react';

import styles from './Chip.module.scss';

interface IProps {
  className?: string,
  children: string | string[],
  onRemove?(e: any): void
}

const Chip: React.FC<IProps> = (props) => {

  return(
    <div className={props.className ? `${styles.Chip} ${props.className}` : `${styles.Chip}`}>
      <div className={styles.text}>{props.children}</div>
      {props.onRemove && <div className={styles.closeWrap}>
        <span>...</span>
        <div onClick={props.onRemove} className={styles.close}></div>
      </div>}
    </div>
  );
}

export default Chip;